import colorConfigs from "../../configs/colorConfigs";

const registerPageStyles = {
  container: {
    display: 'flex',
    flexDirection:'column',
    justifyContent: 'center',
    background:colorConfigs.secondary,
    minHeight: '70vh',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor:colorConfigs.backgrounds.white,
    boxShadow:colorConfigs.backgrounds.boxshadow,
    borderRadius: '8px',
    padding: '24px',
    width:'90%',
},
  paper: {
    p: 0,
    borderRadius: 2,
    backgroundColor: 'background.paper',
  },
  button: {
    mt: 2,
    backgroundColor: colorConfigs.primary,
    color: colorConfigs.secondary,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
    borderRadius: '30px',
  },
  phoneInput: {
    width: '100%',
    marginTop: '10px',
  },
  textField: {
    marginTop: '10px',
  },
};

export default registerPageStyles;